import React from 'react';
import { connect } from 'react-redux';
import { Avatar, Dropdown, Menu } from 'antd';

import CONSTANT from '../../constant';
import MenuAction from '../../reducers/menu/action';
import UserAction from '../../reducers/user';
import { showErrorMessage, showSuccessMessage } from '../../util/index';
import mElectronApi from '../../util/electron';
import Config from '../../config';
import History from '../../util/history';
import avatarImg from '../../resource/img/avatar.svg';
import visitorImg from '../../resource/img/visitor-avatar.svg';
import { safeHttps } from '../../util';

const RequestStatus = CONSTANT.REQUEST_STATUS;

class AccountDropdown extends React.Component {

    constructor(props) {
        super(props);
    }

    checkAccountMenu = () => {
        return (
            <span className="user-menu menu-trigger">
                <Avatar icon="loading" />
            </span>
        );
    }

    handleUserMenuClick = item => {
        const { logout, urlToken, visibleChange, account } = this.props;
        const { isInternational } = account;
        if (item.key === 'menu:logout') {
            logout(
                () => showSuccessMessage.bind(this)('USER.LOGOUT.SUCCESS.MSG'),
                () => showErrorMessage.bind(this)('USER.LOGOUT.FAIL.MSG')
            );
        }
        if (item.key === 'user:clouddata') {
            urlToken((data) => {
                mElectronApi.openLink(null, `${Config.link.cloud_data}?token=${data.urltoken}`);
            }, err => showErrorMessage.bind(this)(null, err.code));
        }
        if (item.key === 'user:profile') {
            History.push('/profile');
        }
        if (item.key === 'user:ifttt') {
            History.push('/user/ifttt');
        }
        if (item.key === 'user:homepage') {
            mElectronApi.openLink(null, `${isInternational ? Config.link.homepage.en : Config.link.homepage.zh}`);
        }
        visibleChange('user', false);
        return true;
    }

    userDropdownMenu = () => {
        const { intlr } = this.props;
        const { messages } = intlr;
        return (
            <Menu className="header-dropdown-menu" onClick={this.handleUserMenuClick.bind(this)}>
                {/* <Menu.Item key="user:clouddata">
                    {messages['MENU.CLOUDLIST']}
                </Menu.Item> */}
                {/* <Menu.Item key="user:ifttt">
                    {messages['IFTTT.TITLE']}
                </Menu.Item> */}
                <Menu.Item key="user:homepage">
                    {messages['USER.HOME_PAGE']}
                </Menu.Item>
                <Menu.Item key="user:profile">
                    {messages['USER.PROFILE']}
                </Menu.Item>
                {/* <Menu.Divider /> */}
                {/* <Menu.Item key="menu:logout">
                    {messages['USER.LOGOUT']}
                </Menu.Item> */}
            </Menu>
        );
    }

    userMenu = () => {
        const { menu, account, visibleChange, project } = this.props;
        const { showLoadingPage, saveStatus } = project;
        const dealWithAccountName = () => {
            const userName = account.data.userName;
            return userName.length > 15 ? userName.substring(0, 14) + '...' : userName;
        };

        return (
            <Dropdown
                disabled={showLoadingPage || saveStatus === CONSTANT.PROJECT_SAVE_STATUS.DOING ? true : false}
                trigger={['click']}
                overlay={this.userDropdownMenu()}
                onVisibleChange={visible => visibleChange('user', visible)}>
                <span id="userMenuTrigger"
                    className={`user-menu menu-trigger ${menu.user ? 'active' : ''}`}>
                    <span className='user-name'>{(account.data && account.data.userName && dealWithAccountName()) || '--'}</span>
                    <Avatar
                        icon = "user"
                        src = {account.data && safeHttps(account.data.headpic) || avatarImg}
                    />
                </span>
            </Dropdown>
        );
    }

    emptyUserMenu = () => {
        return (
            <div className="user-menu menu-trigger" key="login" onClick={() => {
                const { showLoadingPage, saveStatus } = this.props.project;
                if (showLoadingPage || saveStatus === CONSTANT.PROJECT_SAVE_STATUS.DOING) {
                    return;
                }
                History.replace('/login');
            }}>
                <Avatar icon="user" src={visitorImg} />
            </div >
        );
    }

    accountDropdown = () => {
        const { account } = this.props;
        if (account.checkAccountRequest === RequestStatus.PENDING) {
            return this.checkAccountMenu();
        }
        return account.isLogin ? this.userMenu() : this.emptyUserMenu();
    }

    render() {
        return <section className="header-cell">
            {this.accountDropdown()}
        </section>;
    }
}

export default connect(state => ({
    account: state.account,
    menu: state.menu,
    project: state.project,
    intlr: state.intlr
}), dispatch => ({
    urlToken: (successCb, failCb) => dispatch(UserAction.urlToken(successCb, failCb)),
    logout: (successCb, failCb) => dispatch(UserAction.logout(successCb, failCb)),
    visibleChange: (type, visible) => dispatch(MenuAction.visibleChange(type, visible))
}))(AccountDropdown);